module.exports = {
    FIOC_DOC_STATUS_MISSING: 'RN',
    FIOC_DOC_STATUS_MISSING_2: 'RK',
    FIOC_DOC_STATUS_NOT_APLICABLE: 'NA',
    FIOC_DOC_STATUS_NOT_REQUIRED: 'NR',
    FIOC_DOC_STATUS_OK: 'RE',
    FIOC_DOC_STATUS_VALIDATING: 'RV',
    FIOC_WARNING_DAYS_UNTIL_ACCOUNT_BLOCK : 180,
    FIOC_WARNING_DAYS_UNTIL_OPERATIONS_BLOCK : 90,
    FIOC_WARNING_DAYS_UNTIL_POSITIONS_BLOCK : 270
};
